import { useKernelApi } from 'infrastructure/api';
import { useBaseCrudService } from 'framework/crud';
import { storageService } from 'framework/utils';

export type Technology = {
  id: string;
  name: string;
};

export const ENGLISH_ID = 'ENGLISH';

const useTechnologyService = () => {
  const { findAll: findAllFromApi } = useBaseCrudService({
    singleResourceUrl: '/technologies/:id',
    listResourceUrl: '/technologies',
    useService: useKernelApi,
  });

  const { getDataFromStorage } = storageService('technologies', findAllFromApi, '1.04');

  const findById = async (id: any): Promise<Technology> => {
    const technologies = await getDataFromStorage();
    return technologies.find((technology: { id: any }) => technology.id === id) || {};
  };

  return {
    findAll: getDataFromStorage as () => Promise<List<Technology>>,
    findById,
  };
};

export default useTechnologyService;
